import React, { useState } from "react";
import "./add_year.css";
import api from "../../../utils/api";
import toast from "react-hot-toast";

const AddYear = ({ close, btn = "Send", fetchData }) => {
  const [dateFilter, setDateFilter] = useState({ from: "", to: "" });

  const addData = async () => {
    if (dateFilter.from === "" || dateFilter.to === "") {
      toast.error("Please select date range!");
      return;
    }
    await api
      .post("/academic", {
        from: dateFilter.from,
        to: dateFilter.to,
      })
      .then((data) => {
        fetchData();
        setDateFilter({ from: "", to: "" });
        close();
        toast.success("Academic year added!");
      });
  };

  return (
    <div className="delete-card-overlay">
    <div className="year-card">
      <p>Add Academic Year</p>
      <div style={{ display: "flex", gap: "1rem" }}>
        <input
          type="date"
          value={dateFilter.from}
          style={{ padding: "8px" ,backgroundColor:"rgb(229, 229, 229)" ,border:"1px solid #cccccc"}}
          onChange={(e) =>
            setDateFilter((prev) => ({ ...prev, from: e.target.value }))
          }
        />
        <input
          type="date"
          value={dateFilter.to}
          style={{ padding: "8px" ,backgroundColor:"rgb(229, 229, 229)" ,border:"1px solid #cccccc"}}
          onChange={(e) =>
            setDateFilter((prev) => ({ ...prev, to: e.target.value }))
          }
        />
      </div>
      <div className="action-box">
        <button onClick={addData}>{btn}</button>
        <button onClick={close}>No</button>
      </div>
    </div>
    </div>
  );
};

export default AddYear;
